// @ts-nocheck
import React, { useState, useEffect } from "react";

const StepperComponent = () => {
  const [stepLocation, setStepLocation] = useState(0);
  const stepperValue = ["Property Details", "Disclaimers"];

  // Scroll halfway down the page
  const scrollHalfway = () => {
    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;

    // Scroll halfway through the document, accounting for window size
    const scrollPosition = (documentHeight - windowHeight) / 1.4;

    window.scrollTo({
      top: scrollPosition, // Scroll to the halfway point, considering the viewport size
      behavior: "smooth",
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // for smooth scrolling effect
    });
    setStepLocation(0);
  };

  // Handle step change
  const handleStepChange = (index) => {
    setStepLocation(index);

    // If the clicked step is "Disclaimers", scroll halfway down the page
    if (index === 1) {
      scrollHalfway();
    }
    if (index === 0) {
      scrollToTop();
    }
  };

  // Handle scroll direction (up or down)
  const handleWheel = (e) => {
    if (e.deltaY < 0) {
      // Scrolling up
      setStepLocation(0); // Set step to "Property Details"
    }
  };

  // Set up a wheel event listener
  useEffect(() => {
    window.addEventListener("wheel", handleWheel);

    // Clean up the event listener when component unmounts
    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <div className="text-sm font-medium text-center text-gray dark:text-gray-400 dark:border-gray-700">
      <ul className="flex flex-wrap -mb-px">
        {stepperValue.map((item, index) => (
          <li key={index} className="me-2">
            <button
            aria-label="page"
              aria-current="page"
              onClick={() => handleStepChange(index)}
              className={`${
                index === stepLocation
                  ? "active cursor-pointer text-[#FF5C39] border-[#FF5C39]"
                  : "border-transparent"
              } inline-block p-2 border-b-2 rounded-t-lg dark:hover:text-gray-300`}
            >
              {item}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StepperComponent;

